
<div id="loadingContent">
	<p>
	{{message}}
	</p>
	<acc-main-loader></acc-main-loader>
	<div class="spinner-stopped"></div>
	<p id="canClose">You can close this tab when your document has finished downloading.</p>
</div>
